module.exports = __webpack_public_path__ + "img/jianJie.4a64323a.jpg";